import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRestaurantAvailabilityTimes } from '../../api/queries/restaurantShifts';
import { Page } from '../../components';
import AvailabilityContent from './AvailabilityContent';

const Availability = () => {
    const { t } = useTranslation();

    const availabilityTimesQuery = useRestaurantAvailabilityTimes();

    const subtitle = availabilityTimesQuery.data
        ? t('availability.subtitle', {
              shifts: t('availability.shiftsCount', { count: availabilityTimesQuery.data.shifts.length }),
              special: t('availability.specialCount', {
                  count: availabilityTimesQuery.data.specialOpeningHours.length,
              }),
              closed: t('availability.closedCount', { count: availabilityTimesQuery.data.closingDays.length }),
          })
        : undefined;

    return (
        <Page name="availability" title={{ value: t('availability.title'), subtitle }}>
            <AvailabilityContent />
        </Page>
    );
};

export default Availability;
